import { CalendarCheck, Bot, Headset } from 'lucide-react';
import type { FormOption, LeadPath } from '../../types/forms';

interface Props {
  // null = keine konkrete Sportart gewählt → nur Rückruf.
  option: FormOption | null;
  onChoose: (path: LeadPath) => void;
  busy?: boolean;
}

export default function PathSelection({ option, onChoose, busy }: Props) {
  // Alle drei Pfade abgeschaltet (Fehlkonfiguration im Admin) -> nicht ins Leere
  // laufen lassen, sondern direkt zum Rückruf führen.
  const noPathConfigured =
    !!option && !option.allow_instant_booking && !option.allow_ai_call && !option.allow_callcenter;

  return (
    <div className="rf-card">
      {!option && (
        <p className="rf-hint" style={{ marginTop: 0 }}>
          Da du noch keine Sportart ausgewählt hast, finden wir den passenden Kurs
          und einen Termin gemeinsam am Telefon.
        </p>
      )}
      {noPathConfigured && (
        <div className="rf-alert rf-alert--info" style={{ marginTop: 0 }}>
          Für diesen Kurs ist online aktuell keine Terminwahl möglich. Wir melden uns
          telefonisch bei dir.
        </div>
      )}
      <div className="rf-choices">
        {option?.allow_instant_booking && (
          <button className="rf-choice" disabled={busy} onClick={() => onChoose('booking')}>
            <span className="rf-choice__icon"><CalendarCheck size={22} /></span>
            <span>
              <span className="rf-choice__title">Termin direkt buchen</span>
              <span className="rf-choice__desc">
                Sofort einen freien Probetraining-Termin sichern. Dein Einführungsvideo
                bekommst du danach per E-Mail.
              </span>
            </span>
          </button>
        )}

        {option?.allow_ai_call && (
          <button className="rf-choice" disabled={busy} onClick={() => onChoose('ai_call')}>
            <span className="rf-choice__icon"><Bot size={22} /></span>
            <span>
              <span className="rf-choice__title">Anrufen lassen</span>
              <span className="rf-choice__desc">
                Unser KI-Telefonassistent ruft dich an – sofort oder zu deiner Wunschzeit.
              </span>
            </span>
          </button>
        )}

        {/* Ohne gewählten Kurs (option === null, "Ich bin mir nicht sicher") gibt es
            keine Zeile in form_config und damit keinen Schalter zu prüfen – der
            Rückruf bleibt dort der einzige Weg und ist immer verfügbar. */}
        {(!option || option.allow_callcenter || noPathConfigured) && (
          <button className="rf-choice" disabled={busy} onClick={() => onChoose('callcenter')}>
            <span className="rf-choice__icon"><Headset size={22} /></span>
            <span>
              <span className="rf-choice__title">Von einem Mitarbeiter zurückrufen lassen</span>
              <span className="rf-choice__desc">
                Unser Team meldet sich persönlich bei dir und bespricht alles Weitere.
              </span>
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
